/*
 *  Manage department modal dialog
 */
angular.module('qkr.department')
    .controller('ShareDepartmentManagmentModalDialogController', sharedModal);

sharedModal.$inject = ['$uibModalInstance', 'departmentService',
    'messageService', 'FormHelper', 'department', '$scope'];

function sharedModal($uibModalInstance, departmentService,
      messageService, FormHelper, department, $scope) {
    const formHelper = new FormHelper($scope);

    const vm = this;
    let merchantId = null;

    const init = function() {
        vm.department = department;
        vm.saving = false;
        vm.emailSupplier = null;
    };

    vm.shareDepartment = function() {
        vm.saving = true;
        departmentService.createShareRequest(vm.department, merchantId, vm.emailSupplier)
             .then(shareDepartmentCallback, failedRequest);
    };

    vm.getMerchantByEmailSupplier = function() {
        departmentService.getMerchantBySupplierEmail(vm.emailSupplier)
            .then(successRequest, failedRequest);

        function successRequest(response) {
            vm.merchantName = response.data.merchantName;
            merchantId = response.data.merchantId;
        }

        function failedRequest(reason) {
            console.error(reason);
            messageService.errorWithReason(reason.data.exception, '', true);
        }
    };

    vm.hasErrors = function(errors) {
        return Object.keys(errors)[0] !== undefined;
    };

    vm.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    function shareDepartmentCallback(response) {
        const r = formHelper.handleResponse(response);

        if (r.isSuccess()) {
            $uibModalInstance.close('done');
        } else {
             vm.saving = false;
             messageService.errorWithReason(response.data.exception, '', true);
        }
    }

    function failedRequest(reason) {
        messageService.errorWithReason(reason.data.exception, '', true);
    }

    init();
}



// WEBPACK FOOTER //
// ./src/department/controllers/departmentmanagement.share.controller.js